import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";
import RoundedButton from "components/RoundedButton";
import Separator from "components/Separator";
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/this-is-how-these-four-won-a-holiday-in-lockdown`;

  return (
    <MainLayout>
      <NextSeo
        title="This Is How These 4 Won A Holiday In Lockdown | DAYMADE"
        description="We sat down with some of our wonderful winners to delve into their upcoming holidays"
        openGraph={{
          title: 'This Is How These 4 Won A Holiday In Lockdown | DAYMADE',
          description:
            'We sat down with some of our wonderful winners to delve into their upcoming holidays',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/this-is-how-these-four-won-a-holiday-in-lockdown',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'A DAYMADE winner stood in front of a collection of islands protruding from the Mediterranean Sea',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'Win a holiday,Bali,Greece,holiday,win a gift card,trip to Malta,eco holiday,sustainable,winner,lucky,lockdown,planning,2021'
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="A DAYMADE winner stood in front of a collection of islands protruding from the Mediterranean Sea"
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            This Is How These 4 Won A Holiday In <strong>Lockdown</strong>
          </h1>

          <p className="subheading">4 winners, 4 holiday plans sorted</p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Abbi James
          </p>

          <p>
            <span className="bigFirstLetter">L</span>et’s face it, it’s been a
            WHILE since we stepped off that plane, warm overseas-air blowing our
            hair back, catwalking down that runway… but soon enough, we’ll be
            back! Here at DAYMADE, we’re already putting plans in motion with
            our fab travel prize winners, so they can get jetsetting as soon as
            Bo-Jo says <em>hell yeah!</em>
          </p>

          <p>
            We sat down (via email – social distancing is still a thing,
            please!) with some of our wonderful winners to delve into their
            upcoming holiday deets, so read on for our little Q&A!
          </p>

          <h4>Abbie Robinson</h4>

          <p>
            Abbi (
            <a
              href="https://www.instagram.com/abbeth_/"
              target="_blank"
            >
              @abbeth_
            </a>
            ), 24, from Portsmouth, won a £1,000 LuckyTrip gift card!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/ar-1.jpg`}
            alt="DAYMADE winner, Abbi, posing on a balcony at nighttime with palm tree in background"
            className="singleBlogImage"
          />

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: You open up your emails, see that you’ve won a fab prize…what’s
            your reaction?!
          </p>

          <p>“I couldn't believe it when I won - I never win anything!”</p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: You’re the brand-new owner of a £1,000 LuckyTrip gift card!
            So…where you gonna go?
          </p>

          <p>
            “We've seen some amazing options in Mexico, Croatia, Tenerife and
            Africa so we're currently narrowing it down - all very different as
            you can imagine!”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What are you most looking forward to on your trip? Any special
            activities that you just can’t wait for?
          </p>

          <p>
            “…elongating our summer by getting some winter sun is just the
            perfect way to relax and unwind. Cocktails by the pool and water
            sports just sounds like the perfect remedy”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What’s your fave holiday or travel memory?
          </p>

          <p>
            “I have so many favourite holiday memories it's difficult to choose
            - my friends and I rented a villa in Tenerife a few years ago which
            was amazing with all the bars and Siam Park - we had the best time!
            Quad Biking in Turkey with my boyfriend also really stands out in my
            memories, the views were lovely and it was just so fun.”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: Is there anything you’d like to share with our readers?
          </p>

          <p>
            “Absolutely just go for it! I actually entered the draw as a one off
            4 hours before the draw took place, so don't think for a second you
            don't have a chance!”
          </p>

          <div className="doubleImageContainer">
            <img
              src={`${IMAGE_DIRECTORY}/ar-2.jpg`}
              alt="DAYMADE winner, Abbi, posing in front of a mountain in the desert with blue skies in background"
              className="doubleBlogImage"
            />

            <img
              src={`${IMAGE_DIRECTORY}/ar-3.jpg`}
              alt="DAYMADE winner, Abbi, smiling in the arms of her boyfriend on a jeep on holiday"
              className="doubleBlogImage"
            />
          </div>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px' }}
          >
            Join The Draw
          </RoundedButton>

          <h4>Alex Adams</h4>

          <p>
            Alex (
            <a
              href="https://www.instagram.com/aadams2271/"
              target="_blank"
            >
              @aadams2271
            </a>
            ), 25, from Ipswich, won a £2,000 holiday to Bali or Greece!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/aa-1.jpg`}
            alt="DAYMADE winner, Alex, and her boyfriend looking excited"
            className="singleBlogImage"
          />

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: How did you react to finding out you won a £2,500 prize?
          </p>

          <p>
            “I actually got the email with the results on my way home from a
            Scottish camping trip! We were freaking out! We must have looked a
            couple of chaotic frenzy of excitement, we then spent bought some
            ice creams to enjoy while we spent the next half an hour parked at
            the station looking through the possible prizes we could choose
            from.”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What are you most excited about on your getaway?
          </p>

          <p>
            “I’ve been lucky enough to travel a lot in recent years, I always
            look forward to throwing myself into the culture, food, and people.
            A bonus for Bali is all the potential unexplored beauty, I already
            have various points to explore save on google maps, including
            Tegenungan waterfall, the Ubud rice fields and Mt Batur”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What are your fave travel memories?
          </p>

          <p>
            “There are literally so many… I daren’t say it’s my favourite but
            the first that comes to mind is during my time spent on a
            conservation project on the island of Beqa (off the coast of Fiji’s
            main island). I think the best travel memories are mostly defined by
            the people we meet.”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: Fancy sharing anything with our future players/readers?
          </p>

          <p>
            “Just try it out, you can win experiences and gain memories, which
            in my opinion is far better than the typical lottery-style prize of
            money. The money is going to a good cause and the chances of winning
            cool prizes is so high compared to other competitions so it’s a
            win-win!”
          </p>

          <div className="doubleImageContainer">
            <img
              src={`${IMAGE_DIRECTORY}/aa-2.jpg`}
              alt="Tropical forest with pink sunset behind it"
              className="doubleBlogImage"
            />

            <img
              src={`${IMAGE_DIRECTORY}/aa-3.jpg`}
              alt="Blue skies towering above turquoise water with small beached boat nearby"
              className="doubleBlogImage"
            />
          </div>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px' }}
          >
            Join The Draw
          </RoundedButton>

          <h4>Sam Worton</h4>

          <p>Sam from London, won a £500 LuckyTrip holiday to Malta!</p>

          <img
            src={`${IMAGE_DIRECTORY}/sw-1.jpg`}
            alt="DAYMADE winner, Sam, sits on a treetop walkway overlooking a large mountain in the distance"
            className="singleBlogImage"
          />

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: How did you react when you saw that you won a £500 travel prize?
          </p>

          <p>
            “Surprised and shocked! I don’t recall ever winning anything of
            note, and I’d only entered the draw on a bit of a whim, so I really
            wasn’t expecting to get an email saying I’ve won a £500 prize a
            couple of hours later... but after the last year it was an amazing
            feeling!”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What made you decide Malta was *the one*?
          </p>

          <p>
            “My mum and dad went there before I was born and had a brilliant
            time, so I had a glowing reference. It is a place I’ve always been
            curious about visiting and is small enough that 3 nights would feel
            like a nice amount of time to spend there. And of course,
            Mediterranean weather!”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What’s your plan once you touchdown in sunny Malta?
          </p>

          <p>
            “The first hotel looks unreal so can’t wait to spend some time (and
            money) in the pool and beach bar. The cruise will be lots of fun and
            insightful, and generally just getting away and seeing something
            different will be the best part!”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: Fave holiday or travel memory?
          </p>

          <p>
            “Ahhh so many! My last big adventure was spending over a year
            travelling around Australia and Asia from 2018-2019, which was a
            really maturing experience as I went alone and was so rewarding.
            Some of the places I visited, experiences I had and people I met -
            incredible!”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: Anything else you’d like to add?
          </p>

          <p>
            “For a few quid, why not have a go? It’s worth it when you win a fab
            prize for the price of a coffee!”
          </p>

          <div className="doubleImageContainer">
            <img
              src={`${IMAGE_DIRECTORY}/sw-2.jpg`}
              alt="DAYMADE winner, Sam, holding a koala bear in Australia"
              className="doubleBlogImage"
              style={{
                objectPosition: '50% 15%',
              }}
            />

            <img
              src={`${IMAGE_DIRECTORY}/sw-3.jpg`}
              alt="DAYMADE winner, Sam, scuba diving with a turtle"
              className="doubleBlogImage"
            />
          </div>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px' }}
          >
            Join The Draw
          </RoundedButton>

          <h4>Klaire</h4>

          <p>
            Klaire from Blandford Forum, won a £1,000 LuckyTrip holiday to
            Zakynthos, Greece!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/k-1.jpg`}
            alt="Wooden walkway with rope handrails crossing small part of the Mediterranean sea reaching tiny island with trees on"
            className="singleBlogImage"
          />

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What was your reaction to finding out you won an amazing holiday
            for two?
          </p>

          <p>
            “I’m afraid my reactions were very cliché and I thought it was
            probably a scam! I also couldn’t believe I’d won as I never win
            anything (possibly because I never enter anything!)”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What are you most looking forward to doing once you step off that
            plane?
          </p>

          <p>
            “It looks so beautiful. I love Greek food and I’m usually swayed by
            a location based on its culinary reputation so I’m looking forward
            to this most. But as a single mum with two young, boisterous girls I
            am soooo looking forward to enjoying some sun, in peace, with my
            friend.”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: What holiday memory has you reminiscing the good ol’ travel
            times?
          </p>

          <p>
            “A city break to Rome is one of my favourite holiday memories. A
            beautiful city with amazing history and atmosphere, based entirely
            around the food again of course”
          </p>

          <p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
            Q: Anything you’d like to share?
          </p>

          <p>
            “I literally saw this competition whilst flicking through Instagram,
            it helps plant a tree which was my main motive, and it was the night
            before the competition closed, so I decided to enter on a whim. And
            I won! It is well worth entering.”
          </p>

          <Separator />

          <p>
            Here at DAYMADE, we have hundreds of winners each and every week,
            ranging from incredible at-home prizes to all-inclusive dream
            holidays. The majority of our travel prizes are for jaw-dropping
            getaways with our best buds over at LuckyTrip – you don’t literally
            go on holiday <em>with</em> them, but they make your holiday easy
            and hassle-free. With over 400 destinations to choose from, you’re
            sure to find your perfect match. Whether you’re a beach-bum who
            loves the sun, or you just can’t wait for adventure, there’s
            something for everyone!
          </p>

          <p>
            We’re counting down the days until we can (
            <em>safely and responsibly, mind you</em>) get exploring again.
            That’s why we offer LuckyTrip gift cards as prizes in our weekly
            draw, to allow you the ultimate flexibility in where to go, when.
          </p>

          <p>
            We’re also big advocates of investing in a better tomorrow - that’s
            why we’ve partnered up with Eden Reforestation Projects! A tree is
            planted for every purchase, meaning over 320,200 trees have been
            planted on behalf of our amazing players so far. You win, the world
            wins, everybody wins.
          </p>

          <p>Fancy winning your next getaway?</p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px' }}
          >
            Yes, let's go!
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
